// import logo from 'assets/innvolight/InnvoLightLogo.png'
import logo from 'assets/innvolight/InnvoLightLogo-orange.png'
import Product from 'assets/innvolight/Banner/ProductImgNew.png'

export default function Banner() {
  return (
    <div className="flex relative flex-col justify-center items-center h-full min-h-screen">
      {/* Radial Gradient Background from Top */}
      <div className="absolute inset-0 z-0 bg-[url(assets/innvolight/Banner/BG.png)] bg-center bg-no-repeat bg-cover opacity-70" />
      <div className="grid relative pt-20 w-full lg:grid-cols-2 sm:pt-24 lg:pt-20">
        <div className="flex flex-col justify-center items-end">
          <div className="flex flex-col items-center w-full max-w-[810px]">
            <div className="w-full max-w-[240px] sm:max-w-xs lg:max-w-xs xsl:max-w-sm">
              <img
                src={logo}
                className="object-contain w-full h-full gsap-opacity-trans-appear-top"
                alt=""
              />
            </div>
            <h2 className="text-2xl font-bold text-center sm:text-[36px] text-orange 2xl:text-4xl xsl:text-[36px] gsap-opacity-trans-appear">
              AI-powered OCT for precision PCI
            </h2>
          </div>
        </div>
        <div className="flex flex-col items-center lg:items-start pt-[10px] sm:pt-[30px] 2xl:pt-[50px]">
          <div className="w-full max-w-xl">
            <img
              src={Product}
              className="object-contain w-full h-full gsap-scale"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  )
}
